import React, { useState } from "react";
import pic from "../Media/clock.png";
import pic2 from "../Media/prices.png";
import pic3 from "../Media/workers.png";
import pic4 from "../Media/notes.png";
import pic5 from "../Media/safe.png";
import {
  Typography,
  Box,
  Stack,
  Container,
  useMediaQuery,
} from "@mui/material";
import { useTranslation } from "react-i18next";

export default function Carousel() {
  const { t } = useTranslation();

  const [images, setImages] = useState([
    {
      picture: pic,
      caption: "We are here for you 24/7, around the clock.",
    },
    {
      picture: pic5,
      caption: "Get what you want quickly",
    },
    {
      picture: pic2,
      caption: "We offer our services at reasonable prices that suit everyone",
    },
    {
      picture: pic3,
      caption: "our team always ready to serve you",
    },
    {
      picture: pic4,
      caption: "Send us your comments and we will make sure to implement them",
    },
  ]);
  const matches = useMediaQuery("(min-width:770px)");
  return (
    <div style={{ marginBottom: "3%", direction: "ltr" }}>
      <section className="pb-5">
        <Container>
          <div
            className="carousel slide"
            id="carouselExampleIndicators"
            data-ride="carousel"
          >
            <div
              className="carousel-inner"
              style={{
                backgroundColor: "#7ABAF3",
                borderRadius: "20px",
                height: "300px",
                display: "flex",
                flexWrap: "wrap",
              }}
            >
              {images.map((i, k) => (
                <div
                  key={k}
                  className={k === 0 ? "carousel-item active" : "carousel-item"}
                >
                  <Stack direction="row">
                    <Box
                      sx={{ width: "50%", marginLeft: "15%", marginTop: "5%" }}
                    >
                      <Typography
                        sx={{
                          color: "#1D2877",
                          fontSize: "30px",
                          fontWeight: "bold",
                        }}
                      >
                        {t("Mashawiri App")}
                      </Typography>
                      <br />
                      <Typography sx={{ color: "#1D2877", fontSize: "20px" }}>
                        {t(i.caption)}
                      </Typography>
                    </Box>

                    {matches ? (
                      <Box
                        sx={{
                          width: "50%",
                          height: "250px",
                          display: "flex",
                          flexWrap: "wrap",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <img
                          style={{
                            height: "200px",
                            objectFit: "cover",
                            marginLeft: "30px",
                          }}
                          src={i.picture}
                          alt="img-444"
                        />
                      </Box>
                    ) : (
                      <div></div>
                    )}
                  </Stack>
                </div>
              ))}
            </div>
            <button
              className="carousel-control-prev"
              type="button"
              data-bs-target="#carouselExampleIndicators"
              data-bs-slide="prev"
            >
              <span
                className="carousel-control-prev-icon"
                aria-hidden="true"
                style={{ backgroundColor: "transparent", borderRadius: "50px" }}
              >
                {" "}
                <span className="visually-hidden"></span>
              </span>
            </button>
            <button
              className="carousel-control-next"
              type="button"
              data-bs-target="#carouselExampleIndicators"
              data-bs-slide="next"
            >
              <span
                className="carousel-control-next-icon"
                aria-hidden="true"
                style={{ backgroundColor: "transparent", borderRadius: "50px" }}
              >
                {" "}
                <span className="visually-hidden"></span>
              </span>
            </button>
          </div>
        </Container>
      </section>
    </div>
  );
}
